const STATUS_MAP = {
  pending: { cls: 'badge-pending', label: 'Pending' },
  acknowledged: { cls: 'badge-acknowledged', label: 'Acknowledged' },
  resolved: { cls: 'badge-resolved', label: 'Resolved' },
  urgent: { cls: 'badge-urgent', label: 'Urgent' },
}

export default function Badge({ status, children, className = '' }) {
  const key = String(status || '').toLowerCase()
  const meta = STATUS_MAP[key] || STATUS_MAP.pending

  return (
    <span className={`badge ${meta.cls} ${className}`}>
      {children || meta.label}
    </span>
  )
}
